import { API_BASE_URL } from '@/config';
import axios from 'axios';
const axiosConf = axios.create({
  baseURL: API_BASE_URL,
});

axiosConf.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

axiosConf.interceptors.response.use(
  (response) => {
    const errorCode = response?.data?.error?.code;
    const isTokenValid = response?.data?.isTokenValid;
    if (errorCode === 401) {
      handleUnauthorized();
    } else if (isTokenValid === false) {
      handleisTokenValid(false);
    } else if (isTokenValid === true) {
      handleisTokenValid(true);
    }
    if (errorCode === 404) {
      const errorStore = useErrorStore();
      errorStore.setError({
        statusCode: 404,
        message: 'Aradığınız sayfa bulunamadı'
      });
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      handleUnauthorized();
    } else if (status === 500) {
      const errorStore = useErrorStore();
      errorStore.set500Error(true);
      const { $router } = useNuxtApp();
      $router.push('/500');
    }
    if (status === 404) {
      const errorStore = useErrorStore();
      errorStore.setError({
        statusCode: 404,
        message: 'Aradığınız sayfa bulunamadı'
      });
    }
    return Promise.reject(error.response);
  }
);
function handle404Error() {
  const errorStore = useErrorStore();
  errorStore.setError({
    statusCode: 404,
    message: "Aradığınız sayfa bulunamadı.",
  });
}
function handleUnauthorized() {
  const userStore = useMyUserStore();
  localStorage.clear();
  userStore.setToken(null);
  userStore.setIsTokenValid(false);

  const { $router } = useNuxtApp();
  $router.push("/giris-yap");
}
function handleisTokenValid(isTokenValid: boolean) {
  const userStore = useMyUserStore();

  if (isTokenValid === false) {
    // Token kaldır ve isTokenValid'i güncelle
    localStorage.removeItem("token");
    localStorage.setItem("isTokenValid", "false");
    userStore.setToken(null);
    userStore.setIsTokenValid(false);
  } else if (isTokenValid === true) {
    // Eğer isTokenValid true ise, isTokenValid'i localStorage'den kaldır
    localStorage.removeItem("isTokenValid");
    userStore.setIsTokenValid(null);
  }
}
export default axiosConf;
